const CONTACT_MODAL_OPEN_EVENT = 'anovator:open-contact-modal'

function createWhatsAppUrl(value) {
  const number = String(value || '').replace(/\D/g, '')
  return /^\d{7,15}$/.test(number) ? `https://wa.me/${number}` : ''
}

function requestContactModal(trigger) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(CONTACT_MODAL_OPEN_EVENT, {
    detail: { trigger }
  }))
}

module.exports = {
  CONTACT_MODAL_OPEN_EVENT,
  createWhatsAppUrl,
  requestContactModal
}
